/* eslint-disable unicorn/prefer-module */
import { useMemo, useState } from "react";
import { CargarClienteComponent, ClientesListado } from "../../components";
import { useAuthContext } from "../../context/auth";
import "./stylesClienteGestion.scss";

export const CargarCliente = () => {
  const [mostrarCargarCliente, setMostrarCargarCliente] = useState(false);

  const { pais } = useAuthContext() || {};

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const toggleCargarCliente = () => {
    setMostrarCargarCliente(!mostrarCargarCliente);
  };

  return (
    <div className="clientes-gestion">
      <div className="logo-container mb-4">
        <img src={logo} alt={`${pais} Logo`} className="logo" />
      </div>
      <button
        onClick={toggleCargarCliente}
        className={`boton-agregar-cliente ${mostrarCargarCliente ? "cancelar" : "agregar"}`}
      >
        {mostrarCargarCliente ? "Cancelar" : "Agregar Cliente"}
      </button>
      {mostrarCargarCliente && <CargarClienteComponent />}
      <ClientesListado />
    </div>
  );
};
